/**
 * Get page slugs from locale
 * @param {Object} translations - Translations object from locale
 * @returns {Object} Object with all page slugs
 */
export const getPageSlugs = (translations) => {
  return translations?.pages?.slugs || {}
}

/**
 * Get specific page slug
 * @param {Object} translations - Translations object from locale
 * @param {string} key - Slug key (e.g., 'globalHub', 'apps')
 * @returns {string} Page slug
 */
export const getPageSlug = (translations, key) => {
  return translations?.pages?.slugs?.[key] || ''
}

/**
 * Get all segment page slugs with their types
 * @param {Object} translations - Translations object from locale
 * @returns {Array} Array of {slug, type, localeKey} objects
 */
export const getSegmentPageSlugs = (translations) => {
  const slugs = getPageSlugs(translations)
  return [
    { slug: slugs.apps, type: 'apps', localeKey: 'pages.slugs.apps' },
    { slug: slugs.bestSites, type: 'comparison', localeKey: 'pages.slugs.bestSites' },
    { slug: slugs.hookups, type: 'hookups', localeKey: 'pages.slugs.hookups' },
    { slug: slugs.sexDating, type: 'adult', localeKey: 'pages.slugs.sexDating' },
    { slug: slugs.howToDate, type: 'advice', localeKey: 'pages.slugs.howToDate' },
    { slug: slugs.tips, type: 'tips', localeKey: 'pages.slugs.tips' },
    { slug: slugs.topApps, type: 'ranking', localeKey: 'pages.slugs.topApps' }
  ]
}

/**
 * Get global hub slug
 * @param {Object} translations - Translations object from locale
 * @returns {string} Global hub slug
 */
export const getGlobalHubSlug = (translations) => {
  return getPageSlug(translations, 'globalHub')
}

